<div class="guide-layout"
  [class.guide-layout--visual-aid]="isVisualAidCall"
  [class.visual-aid-closed]="isVisualAidCall && !visualAidOpen"
  [class.animation]="isVisualAidCall && visualAidAnimation"
>

  <!-- Visual Aid: left column spanning both rows -->
  @if (isVisualAidCall) {
    <div class="va_visual_aid">
      <app-visual-guide
        [controlService]="controlService"
        [playerService]="playerService"
        [showFullScreen]="false"
      />
    </div>
  }

  <!-- Hint: bottom-right (below avatar), only when hints exist -->
  @if (isVisualAidCall && callStore?.getHints()) {
    <div class="va_hint">
      <app-call-hint
        [hint]="callStore!.getHints()"
        [maxHeight]="'120px'"
      />
    </div>
  }

  <!-- Avatar Video -->
  <qai-call-video
    class="avatar_video"
    [displayName]="avatarName" [description]="aiNotice() ?? undefined" nameBadgeKind="gray-dark"
    [isSpeaking]="showAvatarSpeakingBorder"
    [indicatorStatus]="showAvatarLoadingIndicator ? 'loading' : 'audio'"
  >
    <div class="videosStack" videoSlot>
      <div class="video-canvas-wrapper">
        <video
          id="avatar-video-realtime"
          #avatarVideoRealtime
          [appAvatarPlayer]="realtimeService"
          [attr.playsinline]="true"
          [attr.webkit-playsinline]="true"
          [ngClass]="realtimeService?.customBackgroundUrl ? 'avatar-video-hidden' : 'avatar-video-visible'"
          class="avatar-video-realtime"
        ></video>
        @if (realtimeService?.customBackgroundUrl) {
          <canvas
            id="chroma-canvas"
            #chromaCanvas
            class="chroma-canvas"
          ></canvas>
        }
      </div>
      <audio
        id="avatar-audio-realtime"
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
      ></audio>
    </div>
    @if (showAvatarSpeakingIndicator) {
      <qai-call-audio-indicator size="medium" status="audio" />
    }
    @if (showAvatarLoadingIndicator) {
      <qai-call-audio-indicator size="medium" status="loading" />
    }
  </qai-call-video>

  <!-- User Video - Overlapping at bottom right corner -->
  @if (shouldShowUserVideo && !isVisualAidCall) {
    <qai-call-video
      class="userVideo"
      [displayName]="userName.first"
      [fullName]="userName.full"
      [showInitials]="showUserInitials"
      [isMuted]="!callStore?.getIsMicOn() || callStore?.getIsPaused()"
      [isSpeaking]="showUserSpeakingBorder"
    >
      <video
        videoSlot
        id="user-video"
        muted
        [attr.playsinline]="true"
        [attr.webkit-playsinline]="true"
      ></video>
      @if (showUserSpeakingIndicator) {
        <qai-call-audio-indicator size="small" status="audio" />
      }
    </qai-call-video>
  }

</div>
